const DummyData = [
  {
    id: 'e1',
    title: 'Toilet paper',
    amount: 90,
    date: new Date(2020, 7, 14),
  },
  { id: 'e2', title: 'New Tv', amount: 7999, date: new Date(2021, 2, 12) },
  {
    id: 'e3',
    title: 'Car Insurance',
    amount: 6000,
    date: new Date(2021, 2, 28),
  },
  {
    id: 'e4',
    title: 'New desk',
    amount: 4500,
    date: new Date(2021, 5, 12),
  },
];

export default DummyData;
